import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['form'];
  static classes = ['hide'];
  static values = {uploadurl: String, deleteurl: String};

  autoUpload(event){
    const el = event.currentTarget;
    if(el.value != null && el.value != ""){
      const formData = new FormData(this.formTarget);
      Rails.ajax({
        url: this.uploadurlValue,
        type: "POST",
        dataType: 'json',
        data: formData,
        success: (response) => {
          const viewDiv = document.getElementById("image_view_health_record_image");
          const image = viewDiv.querySelector("img");
          image.src = response.image_url;
          viewDiv.classList.remove(this.hideClass);
          document.getElementById("meeting_result_id").value = response.mr_id;
        }
      });
    }
  }

  removeImage(event){
    const formData = new FormData(this.formTarget);
    Rails.ajax({
      url: this.deleteurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response) => {
        const viewDiv = document.getElementById("image_view_health_record_image");
        const image = viewDiv.querySelector("img");
        image.src = "";
        viewDiv.classList.add(this.hideClass);
      }
    });
  }

  changePrescriptionStatus(event){
    const el = event.currentTarget;
    const medication_guidance_tel = this.formTarget.querySelector('#prescription_medication_guidance_tel');
    if(el.value == "no"){
      medication_guidance_tel.checked = true;
    }
  }

}
